import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Message } from 'src/app/core/class/message';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { CommonService } from 'src/app/core/services/common.service';

@Component({
  selector: 'app-document-download-false-dialog',
  templateUrl: './document-download-false-dialog.component.html',
  styleUrls: ['./document-download-false-dialog.component.scss']
})
export class DocumentDownloadFalseDialogComponent implements OnInit {
  isErrorServer: boolean = false
  errorMessage: string = ''
  constructor(
    public dialogRef: MatDialogRef<DocumentDownloadFalseDialogComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private message: Message,
    private commonService: CommonService
  ) {
    switch (this.data.code) {
      case ErrorCode.TemplateNotActiveOrDeleted: {
        this.errorMessage = this.commonService.format(this.message.getMessage('document_download.template_not_exist_message'), this.data.name)
        break;
      }
      case ErrorCode.CreateUpdateDigitalContract2: {
        this.errorMessage = this.commonService.format(this.message.getMessage('document_download.service_type_not_exist_message'), this.data.name)
        break;
      }
      default: {
        this.isErrorServer = true;
        break;
      }
    }
  }

  ngOnInit() {

  }

  close() {
    if (this.data.selectedFrom) {
      this.dialog.closeAll();
      return;
    }

    this.dialogRef.close();
  }

}
